import { JSX } from "react";

import { IconProps } from "@/@types/general.ts";

const IconMagnifyingGlass = (props: IconProps): JSX.Element => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" fill="none" {...props}>
    <path
      d="M14.4995 25C20.2985 25 24.9995 20.299 24.9995 14.5C24.9995 8.70101 20.2985 4 14.4995 4C8.70052 4 3.99951 8.70101 3.99951 14.5C3.99951 20.299 8.70052 25 14.4995 25Z"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M21.9238 21.9248L27.9989 27.9999" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default IconMagnifyingGlass;
